var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"id":"footer","inset":"","app":""}},[_c('span',{staticClass:"text-caption"},[_vm._v("Pharma Monitor Express © 2022")]),_c('v-spacer'),_c('span',{staticClass:"text-caption"},[_vm._v("Bonnier Pharma Insights")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }